import { POSTGRES_CODES } from "@lib/errors/postgresCodes";
import type { FeatureErrorMapper } from "@lib/errors/types";

export const customerErrorMapper: FeatureErrorMapper = (action, err) => {
  if (
    action === "delete" &&
    err.code === POSTGRES_CODES.FOREIGN_KEY_VIOLATION
  ) {
    return "Cannot delete this customer — they have related orders.";
  }

  if (err.code === POSTGRES_CODES.UNIQUE_VIOLATION) {
    if (
      err.constraint?.includes("email") ||
      err.message.includes("email")
    ) {
      return "A customer with this email already exists.";
    }
    if (
      err.constraint?.includes("external_id") ||
      err.message.includes("external_id")
    ) {
      return "A customer with this external ID already exists.";
    }
    return "A customer with these details already exists.";
  }

  return null;
};
